<template>
  <header class="header">
    <div class="header-container">
      <!-- Logo -->
      <router-link to="/" class="logo">
        <img src="@/assets/icon.png" alt="Kiddoz" style="width: 150px; height: auto;"/>
      </router-link>
      
      <!-- 按钮 -->
      <button class="menu-toggle" @click="toggleMenu" :class="{ 'active': isMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <!-- 导航菜单 -->
      <nav class="nav-menu" :class="{ 'active': isMenuOpen }">
        <router-link to="/" @click="closeMenu">Home</router-link>
        <!-- Ticket&Price -->
        <router-link to="/ticket" @click="closeMenu">Ticket&Price</router-link>
        <!-- Rules -->
        <router-link to="/rules" @click="closeMenu">Rules</router-link>
        <!-- Cafe -->
        <a 
          href="/assets/KiddozMenu.pdf"
          rel="noopener noreferrer"
          @click="closeMenu"
          target="_blank"
        >Cafe</a>
        <!-- Party Booking -->
        <router-link to="/party" @click="closeMenu">Party Booking</router-link>
        <!-- Gallerys -->
        <router-link to="/galleries" @click="closeMenu">Gallerys</router-link>
        <!-- Event -->
        <!-- <router-link to="/event" @click="closeMenu">Event</router-link> -->
        <!-- Contact Us -->
        <router-link to="/contact" @click="closeMenu">Contact Us</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderBar',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : '';
    },
    closeMenu() {
      this.isMenuOpen = false;
      document.body.style.overflow = '';
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

.nav-menu {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.nav-menu a {
  color: #2c3e50;
  text-decoration: none;
  transition: color 0.3s;
}

.nav-menu a:hover {
  color: #42b983;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.menu-toggle span {
  width: 100%;
  height: 3px;
  background-color: #2c3e50;
  transition: all 0.3s;
}

/* 移动端样式 */
@media (max-width: 768px) {
  .menu-toggle {
    display: flex;
  }

  .menu-toggle.active span:nth-child(1) {
    transform: translateY(9px) rotate(45deg);
  }

  .menu-toggle.active span:nth-child(2) {
    opacity: 0;
  }

  .menu-toggle.active span:nth-child(3) {
    transform: translateY(-9px) rotate(-45deg);
  }

  .nav-menu {
    position: fixed;
    top: 0;
    right: -100%;
    width: 70%;
    height: 100vh;
    background-color: white;
    flex-direction: column;
    padding: 80px 2rem 2rem;
    transition: right 0.3s ease;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  }

  .nav-menu.active {
    right: 0;
  }

  .nav-menu a {
    font-size: 1.2rem;
    padding: 1rem 0;
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #eee;
  }
}
</style> 